<template>
    <div class="compare-visualization" v-loading="loading" element-loading-spinner="presupuesto-loader">
        <component :is="chartComponent" :data="data" :dimensions="dimensions"></component>
    </div>
</template>
<style lang="scss">
    .compare-visualization{
        svg{
            width: 100%;
            height: auto;
        }
    }
</style>
<script>
    import axios from 'axios';
    import BarChart from '../Charts/Bar';
    import ScalarChart from '../Charts/Scalar';
    import PieChart from '../Charts/Pie';

    export default{
        data: function(){
            return {
                loading: false,
                data: []
            }
        },
        props: ['query'],
        components:{
            BarChart,
            ScalarChart,
            PieChart
        },
        computed:{
            dimensions: function(){
                let dimensions = {
                    ordinal: [],
                    time: []
                };

                if (this.query.mes && (this.query.mes.indexOf(0) !== -1 || this.query.mes.length >= 2)){
                    dimensions.time.push('mes');
                }
                if (this.query.partida && (this.query.partida.indexOf(0) !== -1 || this.query.partida.length >= 2)){
                    dimensions.ordinal.push('partida');
                }
                if (this.query.beneficiario && (this.query.beneficiario.indexOf(0) !== -1 || this.query.beneficiario.length >= 2)){
                    dimensions.ordinal.push('beneficiario');
                }

                /*
                _.forEach(this.query, function(d, key){
                    if(d.indexOf(0) !== -1){
                        if(['periodo','mes'].indexOf(key) !== -1){
                            dimensions.time.push(key)
                        }else{
                            dimensions.linear.push(key)
                        }
                    }
                });
                */

                return dimensions;
            },
            chartComponent: function(){
                if(this.dimensions.time.length === 1){
                    return 'BarChart';
                }else if (this.dimensions.time.length === 0){
                    if (this.dimensions.ordinal.length === 1){
                        return 'PieChart';
                    }else if(this.dimensions.ordinal.length === 0){
                        return 'ScalarChart';
                    }
                }
            }
        },
        mounted: function(){
            let groupBy = [];
            let where = {};



            _.forEach(this.query, function(d, key){
                if(d.indexOf(0) !== -1) {
                    groupBy.push(key);
                }else if(d.indexOf(-1) !== -1){

                }else{
                    groupBy.push(key);
                    where[key] = d
                }
            });

            this.loading = true;
            axios.get('api/v1/data/pagos', {
                params: {
                    'group-by': JSON.stringify(groupBy),
                    'where': JSON.stringify(where)
                }
            })
                .then((response) => {
                    this.loading = false;
                    this.data = response.data;

                })
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Visualizations/Compare.vue